import { React, useEffect, useState, useRef } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
import ModalAddPost from "../../components/Modal/ModalAddPost";
import CardPost from "../../components/Card/CardPost";
import { serverUrl } from "../../components/Helpers/Config";
import AddGray from "../../common/images-new/add-gray-icon.svg";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  addShowcasePost,
  createShowcase,
  deleteShowcase,
  updateShowcasePublicAccess,
  getMyPosts,
  getShowcases,
  editShowcase,
  getShowcaseDetails,
  SHOWCASE_LOADED,
} from "../../redux/actions/showcase";
import axios from "axios";
import Swal from "sweetalert2";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { staticFiles } from "../../components/Helpers/Static";
import ModalEditShowcase from "../../components/Modal/ModalEditShowcase";
import { tokenAuthorize, trimString } from "../../components/Helpers/Common";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ReactComponent as PresentIconSVG } from "../../common/images-new/presentIcon.svg";
import { TextField } from "@mui/material";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  ButtonCommonTopNew,
  ButtonCommonTopGrey,
  ButtonCommonDelete,
  ActiveSpanColor,
  SideBarNormalCount,
} from "../../pages/Theme";
import { MdOutlinePublic } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import CustomizedToggle from "../../components/Button/ToggleButton";
import SidebarShowcase from "../../components/Sidebar/SidebarShowcase";
import { LuPresentation } from "react-icons/lu";
import Map from "../../components/Map";
import { BsSortUpAlt } from "react-icons/bs";
import { BsSortDown } from "react-icons/bs";
import Modal from "../../components/Modal/ModelNewPopup";
import Tooltip from "@mui/material/Tooltip";
import ModalDraggable from "../../components/Modal/ModalDraggable";
import { toast } from "react-toastify";
import { FaTrashAlt } from "react-icons/fa";
import noDataAvailableImg from "../../common/images-new/no-data-available.png";
import { CommonLoader } from "../../components/Button/Loader";
import ShowcaseReorder from "../../components/Modal/ShowcaseReorderModal";

const SHOWCASE_ICON = staticFiles.book;
const DEFAULT_COVER = staticFiles.coverDefault;
const EDIT_LAYOUT_ICON = staticFiles.editLayout;
const PAPER_ICON = staticFiles.paper;

export default function ShowcaseContainer({ profile, data, ...props }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const userProfile = useSelector((state) => state.auth.user);
  const [showCreateShowcase, setShowCreateShowcase] = useState(false);
  const [showEditShowcase, setShowEditShowcase] = useState(false);
  const [showAddPost, setShowAddPost] = useState(false);
  const [currentShowcase, setCurrentShowcase] = useState(0);
  const [selectedShowcase, setSelectedShowcase] = useState({});
  const [showcasePosts, setShowcasePosts] = useState([]);
  const [showcasePostsCancel, setShowcasePostsCancel] = useState([]);
  const [postsReorderCancel, setpostsReorderCancel] = useState(false);
  const analyticsCardsDetails = useSelector(
    (state) => state.analyticsReducer.card_details || []
  );
  const [showcaseName, setShowcaseName] = useState("");
  const [showcaseNameEmpty, setShowcaseNameEmpty] = useState(false);
  const [showcaseNameExist, setShowcaseNameExist] = useState(false);

  const [targetTab, setTargetTab] = useState("");

  const [selectedPost, setSelectedPost] = useState(0);
  const [addPostFailed, setAddPostFailed] = useState(false);

  const [editPostReorder, seteditPostReorder] = useState(false);

  const newShowcaseStatus = useSelector((state) => state.showcase.new);
  const isLoading = useSelector((state) => state.showcase.isLoading);
  const myPosts = useSelector((state) => state.showcase.myPosts);

  const showcasePostIds = showcasePosts.map((post) => post.id);
  const postOptions = myPosts.filter(
    (post) => !showcasePostIds.includes(post.reflection_id)
  );
  // const showcasePostLoading = useSelector(state => state.showcase.new)

  const location = useLocation();
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectGroup, setSelectGroup] = useState();
  const [competencyGroup, setCompetencyGroup] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [compentencyStatus, setcompentencyStatus] = useState(false);
  const [compentencyLoading, setcompentencyLoading] = useState(false);
  const competency_status = useSelector((state) => state.showcase.competency);

  useEffect(() => {
    setcompentencyStatus(competency_status);
  }, [competency_status]);

  const handleCompetencyUpdate = (bool) => {
    let data = {
      competency_status: bool,
    };
    axios
      .put(serverUrl.ActionCompentencyStatus + userProfile?.guid, data)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getShowcaseDetails());
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  useEffect(() => {
    setcompentencyLoading(true);
    axios
      .get(serverUrl.AnalyticsCompetencyGroups)
      .then((resp) => {
        if (resp.status === 200) {
          setCompetencyGroup(resp?.data?.results);
          setSelectGroup(resp?.data?.results[0]?.competency_group_id);
          setcompentencyLoading(false);
        }
      })
      .catch((err) => {
        setcompentencyLoading(false);
        tokenAuthorize(err?.response?.status);
      });
  }, []);

  useEffect(() => {
    const selectedGroup = competencyGroup?.find(
      (group) => group.competency_group_id === selectGroup
    );

    if (!selectedGroup) return;
    const sortedValueTitles = [...selectedGroup.value_titles].sort((a, b) => {
      if (sortOrder === "asc") {
        return a?.count - b?.count;
      } else {
        return b?.count - a?.count;
      }
    });
    setFilteredData(sortedValueTitles);
  }, [selectGroup, competencyGroup, sortOrder]);

  useEffect(() => {
    if (location.state) {
      const tabId = location.state.tabId ? location.state.tabId : 0;

      const selectedTab = data.findIndex(
        (showcaseData) => showcaseData.id === tabId
      );

      if (selectedTab !== -1) {
        setCurrentShowcase(selectedTab);
      }
    }
  }, [location]);

  useEffect(() => {
    if (showCreateShowcase && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowCreateShowcase(false);
        setTargetTab(showcaseName);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setShowcaseNameEmpty(true);
      }
    }

    if (showEditShowcase && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowEditShowcase(false);
        setTargetTab(showcaseName);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setShowcaseNameEmpty(true);
      }
    }

    if (showAddPost && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowAddPost(false);
        setAddPostFailed(false);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setAddPostFailed(true);
      }
    } else {
    }
  }, [newShowcaseStatus]);

  useEffect(() => {
    try {
      //PROD Issued
      //const post = (data[currentShowcase].posts).sort(function (a, b) { return b.order - a.order });
      const post = data[currentShowcase].posts.sort((a, b) => {
        if (a.order === null) return 1;
        if (b.order === null) return -1;
        return b.order - a.order;
      });
      setShowcasePosts(post);
      setShowcasePostsCancel(post);
      setSelectedShowcase(data[currentShowcase]);
    } catch (err) {}
  }, [data, currentShowcase]);

  useEffect(() => {
    if (targetTab.length > 0) {
      let selectedTab = data.findIndex(
        (showcaseData) => showcaseData.name === targetTab
      );

      if (selectedTab !== -1) {
        setTargetTab("");
        setCurrentShowcase(selectedTab);
      }
    }
  }, [dispatch, data, targetTab]);

  const showSelectedShowcasePost = (index) => {
    if (index >= 0 && index < data.length) {
      setCurrentShowcase(index);
    }
  };

  const handleTogglePublish = () => {
    const showcaseId = data[currentShowcase].id;
    const newPublicAccess = data[currentShowcase].published ? 0 : 1;
    dispatch(updateShowcasePublicAccess(showcaseId, newPublicAccess));
  };

  const handleNewShowcase = () => {
    setShowcaseNameEmpty(false);
    dispatch(createShowcase(showcaseName, userProfile?.learner_profile_id,data.length+1));
  };

  const handleEditShowcase = () => {
    const showcaseId = data[currentShowcase].id;
    setShowcaseNameEmpty(false);
    dispatch(editShowcase(showcaseName?.trim(), showcaseId));
  };

  const handleDeleteShowcase = () => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure to delete this showcase?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteShowcase(data[currentShowcase].id))
          .then(() => {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Showcase has been deleted",
              icon: "success",
            });

            setCurrentShowcase(0);
            if (data.length > 0) {
              // dispatch(getShowcasePost(data[0].showcase_id, 0, 10))
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            Swal.fire({
              heightAuto: false,
              title: "Error",
              text: "Cannot delete the showcase",
              icon: "error",
            });
          });
      }
    });
  };

  const handleOpenModalAddPost = () => {
    setSelectedPost(0);
    setShowAddPost(true);
    dispatch(getMyPosts());
  };

  const handleAddPost = () => {
    let showcaseId = parseInt(data[currentShowcase].id);
    let reflectionId = selectedPost;

    const len = showcasePosts?.length === 0 ? 0 : showcasePosts[0].order;
    if (reflectionId !== 0) {
      dispatch(addShowcasePost(showcaseId, reflectionId, len)).then(() => {
        dispatch(getShowcases());
        //dispatch(getShowcasePost(showcaseId, 0, 10))
      });
    } else {
      setShowAddPost(false);
    }
  };

  const cancelpost = () => {
    if (postsReorderCancel == true) {
      Swal.fire({
        title: "Are you sure?",
        text: "Changes will not be saved.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          seteditPostReorder(false);
          setpostsReorderCancel(false);
          setShowcasePosts((prevState) => {
            let updatedTasks = [...showcasePostsCancel];
            return updatedTasks;
          });
        }
      });
    } else {
      seteditPostReorder(false);
    }
  };

  const saveshowcase = () => {
    seteditPostReorder(false);
    if (postsReorderCancel == true) {
      let data = [];
      let arr = {};
      showcasePosts.map(
        (t) => (
          (arr = {
            reflection_id: t.id,
            order: t.order,
          }),
          data.push(arr)
        )
      );
      let Id = selectedShowcase?.id;
      axios
        .put(serverUrl.ShowCaseReorder + "/" + Id, data)
        .then((resp) => {
          if (resp.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Post has been Updated",
              icon: "success",
            });
            dispatch(getShowcases());
            setpostsReorderCancel(false);
            // showcasePostsCancel(showcasePosts)
            setShowcasePostsCancel((prevState) => {
              let updatedTasks = [...showcasePosts];
              return updatedTasks;
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Post not Updated",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          Swal.fire({
            title: "Error",
            text: "Post not Updated",
            icon: "error",
          });
        });
    }
  };

  const [isEditing, setIsEditing] = useState(false);

  const handleInputBlur = () => {
    if (!showcaseName?.trim()) {
      toast.error("Please enter the showcase name");
    } else {
      if (showcaseName?.trim() !== selectedShowcase?.name?.trim()) {
        handleEditShowcase(showcaseName);
        toast.success("Showcase name has been updated");
        setShowcaseName("");
        setIsEditing(false);
      } else {
        setIsEditing(false);
      }
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus(); // focus after entering edit mode
    }
  }, [isEditing]);

  const [isEditingAddShowcase, setIsEditingAddShowcase] = useState(false);
  const inputAddShowcaseRef = useRef(null);
  const inputAddShowcaseMobileRef = useRef(null);

  const buttonRef = useRef(null);

  useEffect(() => {
    handleAddShowcaseFocus();
  }, [isEditingAddShowcase]);

  const handleAddShowcaseFocus = () => {
    if (isEditingAddShowcase && inputAddShowcaseRef.current) {
      inputAddShowcaseRef.current.focus(); // focus after entering edit mode
    }
    if (isEditingAddShowcase && inputAddShowcaseMobileRef.current) {
      inputAddShowcaseMobileRef.current.focus(); // focus after entering edit mode
    }
  };
  const handleInputAddShowcaseBlur = (e) => {
    if (e?.nativeEvent?.relatedTarget?.id === buttonRef?.current?.id) {
      handleAddShowcaseFocus();
      return;
    }
    setIsEditingAddShowcase(false);
    // setIsEditingAddShowcase(false);
    // if (!showcaseName?.trim()) {
    //     // setIsEditingAddShowcase(false);
    //     // toast.error("Please enter the showcase name");
    // }
    // else {
    //     handleNewShowcase(showcaseName);
    //     toast.success("New showcase created successfully");
    //     setShowcaseName("");
    //     setIsEditingAddShowcase(false);
    // }
  };

  const handleCreateShowcase = () => {
    if (showcaseName?.trim() == "" || !showcaseName?.trim()) {
      handleAddShowcaseFocus();
      toast.error("Please enter the showcase name");
    } else {
      handleNewShowcase(showcaseName);
      toast.success("New showcase created successfully");
      setShowcaseName("");
      setIsEditingAddShowcase(false);
    }
  };
  const [IsOpenReorderPost, setIsOpenReorderPost] = useState(false);
  const ModalReorderPost = (
    <div>
      <ModalDraggable
        showcase={showcasePosts}
        selectedShowcase={selectedShowcase}
        onClose={() => setIsOpenReorderPost(false)}
      />
    </div>
  );

  const updateShowcase = (index) => {
    axios
      .get(serverUrl.Showcase)
      .then((resp) => {
        if (resp.status === 200) {
          let showcases = resp.data;

          dispatch({
            type: SHOWCASE_LOADED,
            payload: { showcases },
          });
          setCurrentShowcase(index);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        dispatch({
          type: SHOWCASE_LOADED,
          errors: [err],
        });
      });
  };
  const reorderShowcase = (item, index) => {
    let data = {
      orders: item,
    };
    axios
      .put(serverUrl.ShowcaseReorder, data)
      .then((resp) => {
        Swal.fire({
          title: "Success",
          text: "Showcase has been reordered successfully",
          icon: "success",
        });
        updateShowcase(index);
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };
  const [IsOpenReorderShowcase, setIsOpenReorderShowcase] = useState(false);
  const ModalReorderShowcase = (
    <div>
      <ShowcaseReorder
        showcase={data}
        onSave={(items, index) => {
          reorderShowcase(items, index);
        }}
        index={currentShowcase}
        onClose={() => setIsOpenReorderShowcase(false)}
      />
    </div>
  );

  return (
    <>
      <Modal
        isOpen={IsOpenReorderPost}
        onClose={() => setIsOpenReorderPost(false)}
        header="Reorder post"
      >
        {ModalReorderPost}
      </Modal>
      <Modal
        isOpen={IsOpenReorderShowcase}
        onClose={() => setIsOpenReorderShowcase(false)}
        header="Reorder showcase"
      >
        {ModalReorderShowcase}
      </Modal>

      <div className="space-y-4 lg:space-y-0 lg:grid lg:grid-cols-4 lg:gap-4 mt-4">
        {/* Map Card */}
        <div className="space-y-4">
          <div className="hidden lg:flex">
            <div className="cardBackgroundColor p-6 rounded-lg h-full w-full">
              <div className="flex justify-between gap-1 pb-2">
                <h3 className="text-xl font-bold blackColor">
                  {isEditingAddShowcase ? (
                    <>
                      <input
                        className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                        type="text"
                        ref={inputAddShowcaseRef}
                        placeholder="Add showcase"
                        value={showcaseName ? showcaseName : showcaseName}
                        onChange={(e) => setShowcaseName(e.target.value)}
                        onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleCreateShowcase();
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>Showcase</>
                  )}
                </h3>
                {!isEditingAddShowcase ? (
                  <div className="flex items-center gap-2">
                    {data.length > 1 && (
                      <Tooltip title={"Reorder showcase"} placement="top" arrow>
                        <ButtonCommonTopNew
                          className="p-1 w-8 flex items-center justify-center cursor-pointer rounded-lg"
                          onClick={() => {
                            setIsOpenReorderShowcase(true);
                          }}
                        >
                          <SwapVertIcon className="cursor-pointer text-xl primaryIcon w-5 h-5" />
                        </ButtonCommonTopNew>
                      </Tooltip>
                    )}
                    <Tooltip title={"New showcase"} placement="top" arrow>
                      <ButtonCommonTopNew
                        className="flex items-center w-8 justify-center p-1 rounded-lg cursor-pointer"
                        onClick={() => {
                          setIsEditingAddShowcase(true);
                          setShowcaseName("");
                        }}
                      >
                        <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  </div>
                ) : (
                  <Tooltip title={"Add showcase"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="flex items-center border p-1 rounded-lg cursor-pointer"
                      ref={buttonRef}
                      id="blur"
                      tabIndex={0}
                      onClick={() => {
                        handleCreateShowcase();
                      }}
                    >
                      <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
              </div>
              {data.map((items, index) => {
                return (
                  <SidebarShowcase
                    data={items}
                    index={index}
                    selectedId={currentShowcase}
                    setPage={showSelectedShowcasePost}
                  />
                );
              })}
            </div>
          </div>
          <div className="">
            <div className="cardBackgroundColor p-6 rounded-lg">
              <h4 className="text-xl blackColor font-bold mb-2">My Map</h4>
              <div className="flex items-center justify-center w-full">
                <Map />
              </div>
            </div>
          </div>
          <div className="">
            <div className="cardBackgroundColor p-6 rounded-lg">
              <div className="flex justify-between items-center">
                <h4 className="text-xl blackColor font-bold">
                  {filteredData?.length !== 0
                    ? competencyGroup
                        ?.filter(
                          (group) => group.competency_group_id === selectGroup
                        )[0]
                        ?.name?.toUpperCase()
                    : "Values"}
                </h4>
                <div className="flex flex-wrap justify-between gap-3 items-center">
                  {/* {filteredData?.length !== 0 && (
                    <>
                      {compentencyStatus ? (
                        <>
                          <Tooltip
                            title={"Click to disable in public view"}
                            placement="top"
                            arrow
                          >
                            <span>
                              <MdOutlinePublic
                                className="w-6 h-6 primaryIcon cursor-pointer"
                                onClick={() => {
                                  setcompentencyStatus(false);
                                  handleCompetencyUpdate(false);
                                }}
                              />
                            </span>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Tooltip
                            title={"Click to enable in public view"}
                            placement="top"
                            arrow
                          >
                            <span>
                              <IoMdLock
                                className="w-6 h-6 secondaryIcon cursor-pointer"
                                onClick={() => {
                                  setcompentencyStatus(true);
                                  handleCompetencyUpdate(true);
                                }}
                              />
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </>
                  )} */}
                  {filteredData.length !== 0 && (
                    <Tooltip title={"Published/Private"} placement="top" arrow>
                      <ButtonCommonTopNew
                        className="flex items-center border p-1 px-2 rounded-lg gap-0.5 cursor-pointer"
                        onClick={() => {
                          if (compentencyStatus) {
                            setcompentencyStatus(false);
                            handleCompetencyUpdate(false);
                          } else {
                            setcompentencyStatus(true);
                            handleCompetencyUpdate(true);
                          }
                        }}
                      >
                        {compentencyStatus ? (
                          <>
                            <MdOutlinePublic className="w-6 h-6 primaryIcon" />{" "}
                          </>
                        ) : (
                          <>
                            <IoMdLock className="w-6 h-6 secondaryIcon" />
                          </>
                        )}
                        <CustomizedToggle
                          checked={
                            compentencyStatus ? compentencyStatus : false
                          }
                          onChange={() => {
                            if (compentencyStatus) {
                              setcompentencyStatus(false);
                              handleCompetencyUpdate(false);
                            } else {
                              setcompentencyStatus(true);
                              handleCompetencyUpdate(true);
                            }
                            // handleTogglePublish();
                          }}
                        />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  )}
                  {filteredData?.length !== 0 && (
                    <>
                      <div
                        className="flex gap-3 cursor-pointer"
                        onClick={() => {
                          setSortOrder(sortOrder == "asc" ? "desc" : "asc");
                        }}
                      >
                        {sortOrder == "asc" ? (
                          <>
                            <Tooltip
                              title={"Click to sort by descending"}
                              placement="top"
                              arrow
                            >
                              <span>
                                <BsSortUpAlt className="w-6 h-6 primaryIcon" />
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            <Tooltip
                              title={"Click to sort by ascending"}
                              placement="top"
                              arrow
                            >
                              <span>
                                <BsSortDown className="w-6 h-6 primaryIcon" />
                              </span>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {filteredData?.length !== 0 && (
                <>
                  <ul className="pl-5 list-disc my-3 overflow-y-auto ">
                    {filteredData?.map((item, index) => {
                      // const count = item?.count || 0;
                      // const percent = maxCount ? (count / maxCount) * 100 : 0;
                      return (
                        <>
                          {item?.count !== 0 && (
                            <li
                              key={index}
                              className="flex justify-between py-2 items-center gap-2"
                            >
                              <li className="lightColor text-sm">
                                {item.value_title}
                              </li>
                              <span
                                className={`px-2 text-xs rounded-full h-5 w-5 flex items-center justify-center blueBackGroundColor text-white`}
                              >
                                {item?.count || 0}
                              </span>
                            </li>
                          )}
                        </>
                      );
                    })}
                  </ul>
                </>
              )}
              {compentencyLoading && (
                <div className="w-full flex items-center justify-center h-full">
                  <CommonLoader />
                </div>
              )}
              {!compentencyLoading && filteredData?.length == 0 && (
                <div className="w-full flex items-center justify-center h-full">
                  <div className="w-full flex items-center justify-center h-full">
                    <img
                      src={noDataAvailableImg}
                      alt="pics"
                      className="overflow-hidden w-52"
                    />
                  </div>
                </div>
              )}
              <div className={`flex gap-2 flex-wrap px-5 justify-center pt-2`}>
                {filteredData?.length !== 0 && (
                  <>
                    {competencyGroup?.map((i, index) => (
                      <>
                        {selectGroup == i.competency_group_id ? (
                          <ButtonCommonTopNew
                            className="px-2 border p-1 text-xs rounded-lg cursor-pointer"
                            onClick={() => {
                              setSelectGroup(i.competency_group_id);
                            }}
                          >
                            {i?.name?.toUpperCase()}
                          </ButtonCommonTopNew>
                        ) : (
                          <ButtonCommonTopGrey
                            className="px-2 border p-1 text-xs rounded-lg cursor-pointer"
                            onClick={() => {
                              setSelectGroup(i.competency_group_id);
                              setSortOrder("desc");
                            }}
                          >
                            {i?.name?.toUpperCase()}
                          </ButtonCommonTopGrey>
                        )}
                      </>
                    ))}
                  </>
                )}
                <p className="text-sm lightColor w-full mt-auto text-center">
                  {
                    analyticsCardsDetails?.filter(
                      (x) => x.card_name == "ca_values"
                    )[0]?.simple_description
                  }
                  ​
                </p>
              </div>
            </div>
          </div>
          <div className="flex lg:hidden">
            <div className="cardBackgroundColor p-6 rounded-lg h-full w-full">
              <div className="flex justify-between gap-1 pb-2">
                <h3 className="text-xl font-bold blackColor">
                  {isEditingAddShowcase ? (
                    <>
                      <input
                        className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                        type="text"
                        ref={inputAddShowcaseMobileRef}
                        placeholder="Add showcase"
                        value={showcaseName ? showcaseName : showcaseName}
                        onChange={(e) => setShowcaseName(e.target.value)}
                        onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleCreateShowcase();
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>Showcase</>
                  )}
                </h3>
                {!isEditingAddShowcase ? (
                  <Tooltip title={"New showcase"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="flex items-center border p-1 rounded-lg cursor-pointer"
                      onClick={() => {
                        setIsEditingAddShowcase(true);
                        setShowcaseName("");
                      }}
                    >
                      <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                ) : (
                  <Tooltip title={"Add showcase"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="flex items-center border p-1 rounded-lg cursor-pointer"
                      ref={buttonRef}
                      id="blur"
                      tabIndex={0}
                      onClick={() => {
                        handleCreateShowcase();
                      }}
                    >
                      <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
              </div>
              {data.map((items, index) => {
                return (
                  <SidebarShowcase
                    data={items}
                    index={index}
                    selectedId={currentShowcase}
                    setPage={showSelectedShowcasePost}
                  />
                );
              })}
            </div>
          </div>
          {/* <div className="">
                                <div className="cardBackgroundColor p-6 rounded-lg flex lg:flex-nowrap flex-wrap">
                                    <h4 className="text-base blackColor text-start font-semibold">Display my values and competencies widget</h4>
                                    <div className="flex -mt-1.5">
                                        <CustomizedToggle checked={toggle} onChange={() => setToggle(!toggle)} />
                                    </div>
                                </div>
                            </div> */}
        </div>

        {/* Post Section */}
        <div className="md:col-span-3 space-y-4">
          <div className="cardBackgroundColor p-6 rounded-lg">
            <div className="cardBackgroundColor rounded-lg ">
              <div className="overflow-y-auto space-y-4">
                {data && data.length !== 0 ? (
                  <>
                    <div className="">
                      <div className="flex flex-col md:flex-row md:justify-between md:items-center rounded-lg reflectionbackgroundColor p-2 pl-3">
                        <h2 className="text-xl flex font-bold blackColor md:mb-0 gap-1">
                          {isEditing ? (
                            <>
                              <input
                                className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-10 w-full md:w-96 border-gray-500"
                                type="text"
                                ref={inputRef}
                                placeholder={selectedShowcase.name}
                                value={
                                  showcaseName ? showcaseName : showcaseName
                                }
                                onChange={(e) =>
                                  setShowcaseName(e.target.value)
                                }
                                onBlur={handleInputBlur}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleInputBlur();
                                  }
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <span
                                className="cursor-pointer flex gap-2"
                                onClick={() => {
                                  setIsEditing(true);
                                  setShowcaseName(selectedShowcase.name);
                                  setIsEditingAddShowcase(false);
                                }}
                              >
                                {selectedShowcase?.name}
                                <Tooltip
                                  title={"Edit showcase"}
                                  placement="top"
                                  arrow
                                >
                                  <BorderColorOutlinedIcon
                                    fontSize="small"
                                    className="w-4 h-4 cursor-pointer mt-1 primaryIcon editIcon"
                                  />
                                </Tooltip>
                              </span>
                            </>
                          )}
                        </h2>
                        <div className="items-center space-x-2 flex-wrap text-sm hidden lg:flex">
                          <ButtonCommonTopNew
                            className="flex items-center border p-2 rounded-lg gap-1 cursor-pointer text-sm mb-2 md:mb-0"
                            onClick={handleOpenModalAddPost}
                          >
                            <AddOutlinedIcon
                              fontSize="small"
                              className="w-4 h-4 cursor-pointer primaryIcon"
                            />
                            Add Post
                          </ButtonCommonTopNew>
                          {showcasePosts.length > 0 && (
                            <Tooltip title={"Present"} placement="top" arrow>
                              <ButtonCommonTopNew
                                className="p-2 cursor-pointer rounded-lg"
                                onClick={() =>
                                  history.push(
                                    `present/${selectedShowcase?.id}`
                                  )
                                }
                              >
                                <LuPresentation className="cursor-pointer primaryIcon w-5 h-5" />
                              </ButtonCommonTopNew>
                            </Tooltip>
                          )}
                          {showcasePosts.length > 1 && (
                            <Tooltip
                              title={"Reorder post"}
                              placement="top"
                              arrow
                            >
                              <ButtonCommonTopNew
                                className="p-1.5 cursor-pointer rounded-lg"
                                onClick={() => {
                                  setIsOpenReorderPost(true);
                                }}
                              >
                                <SwapVertIcon className="cursor-pointer text-xl primaryIcon w-5 h-5" />
                              </ButtonCommonTopNew>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={"Delete showcase"}
                            placement="top"
                            arrow
                          >
                            <ButtonCommonDelete
                              className="p-2.5 cursor-pointer rounded-lg"
                              onClick={handleDeleteShowcase}
                            >
                              <FaTrashAlt className="deleteColor w-4 h-4 cursor-pointer" />
                            </ButtonCommonDelete>
                          </Tooltip>
                          <Tooltip
                            title={"Published/Private"}
                            placement="top"
                            arrow
                          >
                            <ButtonCommonTopNew
                              className="flex items-center border p-1 px-2 rounded-lg gap-0.5 cursor-pointer"
                              onClick={handleTogglePublish}
                            >
                              {selectedShowcase &&
                              selectedShowcase.published ? (
                                <>
                                  <MdOutlinePublic className="w-6 h-6 primaryIcon" />{" "}
                                </>
                              ) : (
                                <>
                                  <IoMdLock className="w-6 h-6 secondaryIcon" />
                                </>
                              )}
                              <CustomizedToggle
                                checked={
                                  selectedShowcase && selectedShowcase.published
                                    ? selectedShowcase.published
                                    : false
                                }
                                onChange={() => {
                                  handleTogglePublish();
                                }}
                              />
                            </ButtonCommonTopNew>
                          </Tooltip>
                        </div>
                      </div>
                      <div className="flex items-center justify-center space-x-2 flex-wrap pt-4 text-sm lg:hidden pb-2">
                        <ButtonCommonTopNew
                          className="flex items-center border p-2 rounded-lg gap-1 cursor-pointer text-sm"
                          onClick={handleOpenModalAddPost}
                        >
                          <AddOutlinedIcon
                            fontSize="small"
                            className="w-4 h-4 cursor-pointer primaryIcon"
                          />
                          Add Post
                        </ButtonCommonTopNew>
                        {showcasePosts.length > 0 && (
                          <Tooltip title={"Present"} placement="top" arrow>
                            <ButtonCommonTopNew
                              className="p-2 cursor-pointer rounded-lg"
                              onClick={() =>
                                history.push(`present/${selectedShowcase?.id}`)
                              }
                            >
                              <LuPresentation className="cursor-pointer primaryIcon w-5 h-5" />
                            </ButtonCommonTopNew>
                          </Tooltip>
                        )}
                        {showcasePosts.length > 1 && (
                          <Tooltip title={"Reorder post"} placement="top" arrow>
                            <ButtonCommonTopNew
                              className="p-1.5 cursor-pointer rounded-lg"
                              onClick={() => {
                                setIsOpenReorderPost(true);
                              }}
                            >
                              <SwapVertIcon className="cursor-pointer text-xl primaryIcon w-5 h-5" />
                            </ButtonCommonTopNew>
                          </Tooltip>
                        )}
                        <Tooltip
                          title={"Delete showcase"}
                          placement="top"
                          arrow
                        >
                          <ButtonCommonDelete
                            className="p-2.5 cursor-pointer rounded-lg"
                            onClick={handleDeleteShowcase}
                          >
                            <FaTrashAlt className="deleteColor w-4 h-4 cursor-pointer" />
                          </ButtonCommonDelete>
                        </Tooltip>
                        <Tooltip
                          title={"Published/Private"}
                          placement="top"
                          arrow
                        >
                          <ButtonCommonTopNew
                            className="flex items-center border p-1 px-2 rounded-lg gap-0.5 cursor-pointer"
                            onClick={handleTogglePublish}
                          >
                            {selectedShowcase && selectedShowcase.published ? (
                              <>
                                <MdOutlinePublic className="w-6 h-6 primaryIcon" />{" "}
                              </>
                            ) : (
                              <>
                                <IoMdLock className="w-6 h-6 secondaryIcon" />
                              </>
                            )}
                            <CustomizedToggle
                              checked={
                                selectedShowcase && selectedShowcase.published
                                  ? selectedShowcase.published
                                  : false
                              }
                              onChange={() => {
                                handleTogglePublish();
                              }}
                            />
                          </ButtonCommonTopNew>
                        </Tooltip>
                      </div>
                      <ModalEditShowcase
                        handleClose={() => setShowEditShowcase(false)}
                        show={showEditShowcase}
                        onChange={(e) => setShowcaseName(e.target.value)}
                        onClick={() => handleEditShowcase(showcaseName)}
                        selectedShowcase={selectedShowcase.name}
                        showcaseName={showcaseName}
                        showcaseNameEmpty={showcaseNameEmpty}
                        showcaseNameExist={showcaseNameExist}
                        showcaseLoader={newShowcaseStatus.isLoading}
                      />
                    </div>
                    {!isLoading && showcasePosts ? (
                      <div>
                        <div className="flex flex-row relative mx-3">
                          <ModalAddPost
                            show={showAddPost}
                            handleClose={() => setShowAddPost(false)}
                            onClick={handleAddPost}
                            dropdownOption={postOptions}
                            value={selectedPost}
                            onChange={(e) => setSelectedPost(e.target.value)}
                            addPostLoader={newShowcaseStatus.isLoading}
                            failed={addPostFailed}
                            tabId={data[currentShowcase].id}
                            showcasesCount={
                              showcasePosts?.length > 0
                                ? showcasePosts?.length
                                : 0
                            }
                          />
                        </div>
                        {showcasePosts.length != 0 ? (
                          showcasePosts?.map((post, index) => (
                            <>
                              <div className="flex flex-col">
                                <CardPost
                                  post={post}
                                  profile={profile}
                                  tabId={data[currentShowcase].id}
                                />
                              </div>
                            </>
                          ))
                        ) : (
                          <>
                            <div className="w-full flex items-center justify-center h-full">
                              <div className="w-full flex items-center justify-center h-full">
                                <img
                                  src={noDataAvailableImg}
                                  alt="pics"
                                  className="overflow-hidden w-52"
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="w-full flex justify-center">
                        <CommonLoader />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex flex-col space-y-5 justify-center items-center text-gray-400 mt-10 mb-5">
                    <img
                      className="h-80 w-80"
                      src={SHOWCASE_ICON}
                      alt="showcase"
                    />
                    <p className="text-3xl text-center">
                      Welcome to Showcase page!
                    </p>
                    <p className="w-4/6 text-center">
                      Uh oh it’s look like you don’t have anything yet, let’s
                      create a&nbsp;
                      <Link to="/journal/new" className="nav-navigate">
                        <ActiveSpanColor className="hover:underline">
                          new post
                        </ActiveSpanColor>
                      </Link>{" "}
                      and add them to your&nbsp;
                      <a
                        onClick={() => setShowCreateShowcase(true)}
                        className="cursor-pointer nav-navigate"
                      >
                        <ActiveSpanColor className="hover:underline">
                          showcase
                        </ActiveSpanColor>
                      </a>{" "}
                      here
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <ModalCreateShowcase
            handleClose={() => setShowCreateShowcase(false)}
            show={showCreateShowcase}
            onChange={(e) => setShowcaseName(e.target.value)}
            onClick={handleNewShowcase}
            showcaseName={showcaseName}
            showcaseNameEmpty={showcaseNameEmpty}
            showcaseNameExist={showcaseNameExist}
            showcaseLoader={newShowcaseStatus.isLoading}
          />
        </div>
      </div>
    </>
  );
}

// import { React, useEffect, useState, useRef } from "react";
// import { useLocation } from "react-router-dom";

// import Button from "../../components/Button/Button";
// import ShowcaseTab from "../../components/Navbar/ShowcaseTab";
// import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
// import ModalAddPost from "../../components/Modal/ModalAddPost";
// import ButtonSquare from "../../components/Button/ButtonSquare";
// import TogglePublish from "../../components/Button/TogglePublish";
// import CardBlue from "../../components/Card/CardBlue";
// import CardPost from "../../components/Card/CardPost";
// import { serverUrl } from "../../components/Helpers/Config";
// import AddGray from "../../common/images-new/add-gray-icon.svg"

// import { useDispatch, useSelector } from "react-redux";
// import {
//     addShowcasePost,
//     createShowcase, deleteShowcase,
//     updateShowcasePublicAccess,
//     getMyPosts, getShowcases, editShowcase
// } from "../../redux/actions/showcase";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import { staticFiles } from "../../components/Helpers/Static";
// import ModalEditShowcase from "../../components/Modal/ModalEditShowcase";
// import { MdAdd } from 'react-icons/md';
// import { tokenAuthorize } from "../../components/Helpers/Common";
// import { ButtonCommonTop } from "../Theme";
// import ShowcaseSideBar from "./ShowcaseSideBar";

// export default function ShowcaseContainer({ profile, data, ...props }) {
//     const dispatch = useDispatch()
//     const userProfile = useSelector(state => state.auth.user)
//     const [showCreateShowcase, setShowCreateShowcase] = useState(false)
//     const [showEditShowcase, setShowEditShowcase] = useState(false)
//     const [showAddPost, setShowAddPost] = useState(false)
//     const [currentShowcase, setCurrentShowcase] = useState(0);
//     const [selectedShowcase, setSelectedShowcase] = useState({});
//     const [showcasePosts, setShowcasePosts] = useState([])
//     const [showcasePostsCancel, setShowcasePostsCancel] = useState([])
//     const [postsReorderCancel, setpostsReorderCancel] = useState(false)

//     const [showcaseName, setShowcaseName] = useState('')
//     const [showcaseNameEmpty, setShowcaseNameEmpty] = useState(false)
//     const [showcaseNameExist, setShowcaseNameExist] = useState(false)

//     const [targetTab, setTargetTab] = useState('')

//     const [selectedPost, setSelectedPost] = useState(0)
//     const [addPostFailed, setAddPostFailed] = useState(false)

//     const [editPostReorder, seteditPostReorder] = useState(false)

//     const newShowcaseStatus = useSelector(state => state.showcase.new)
//     const isLoading = useSelector(state => state.showcase.isLoading)
//     const myPosts = useSelector(state => state.showcase.myPosts)

//     const showcasePostIds = showcasePosts.map((post) => (post.id))
//     const postOptions = myPosts.filter((post) => !showcasePostIds.includes(post.reflection_id))
//     // const showcasePostLoading = useSelector(state => state.showcase.new)

//     const location = useLocation();

//     useEffect(() => {
//         if (location.state) {
//             const tabId = location.state.tabId ? location.state.tabId : 0;

//             const selectedTab = data.findIndex(showcaseData => showcaseData.id === tabId);

//             if (selectedTab !== -1) {
//                 setCurrentShowcase(selectedTab)
//             }
//         }
//     }, [location]);

//     useEffect(() => {
//         if (showCreateShowcase && !newShowcaseStatus.isLoading) {
//             if (newShowcaseStatus.isSuccess) {
//                 setShowCreateShowcase(false)
//                 setTargetTab(showcaseName);
//             }
//             else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
//                 setShowcaseNameEmpty(true);
//             }
//         }

//         if (showEditShowcase && !newShowcaseStatus.isLoading) {
//             if (newShowcaseStatus.isSuccess) {
//                 setShowEditShowcase(false)
//                 setTargetTab(showcaseName);
//             }
//             else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
//                 setShowcaseNameEmpty(true);
//             }
//         }

//         if (showAddPost && !newShowcaseStatus.isLoading) {

//             if (newShowcaseStatus.isSuccess) {
//                 setShowAddPost(false)
//                 setAddPostFailed(false);
//             }
//             else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
//                 setAddPostFailed(true);

//             }
//         }

//         else { }

//     }, [newShowcaseStatus])

//     useEffect(() => {
//         try {
//             //PROD Issued
//             //const post = (data[currentShowcase].posts).sort(function (a, b) { return b.order - a.order });
//             const post = (data[currentShowcase].posts).sort((a, b) => {
//                 if (a.order === null) return 1;
//                 if (b.order === null) return -1;
//                 return b.order - a.order;
//             });
//             setShowcasePosts(post);
//             setShowcasePostsCancel(post);
//             setSelectedShowcase(data[currentShowcase])
//         }
//         catch (err) { }
//     }, [data, currentShowcase])

//     useEffect(() => {
//         if (targetTab.length > 0) {
//             let selectedTab = data.findIndex(showcaseData => showcaseData.name === targetTab)

//             if (selectedTab !== -1) {
//                 setTargetTab('');
//                 setCurrentShowcase(selectedTab)
//             }
//         }
//     }, [dispatch, data, targetTab])

//     const showSelectedShowcasePost = (index) => {
//         if ((index >= 0) && (index < data.length)) {
//             setCurrentShowcase(index)
//         }
//     }

//     const handleTogglePublish = () => {
//         const showcaseId = data[currentShowcase].id
//         const newPublicAccess = (data[currentShowcase].published ? 0 : 1)
//         dispatch(updateShowcasePublicAccess(showcaseId, newPublicAccess))
//     }

//     const handleNewShowcase = () => {
//         setShowcaseNameEmpty(false);
//         dispatch(createShowcase(showcaseName, userProfile?.learner_profile_id))
//     }

//     const handleEditShowcase = () => {
//         const showcaseId = data[currentShowcase].id

//         setShowcaseNameEmpty(false);
//         dispatch(editShowcase(showcaseName, showcaseId))
//     }

//     const handleDeleteShowcase = () => {
//         Swal.fire({
//             heightAuto: false,
//             title: "Confirmation",
//             text: "Are you sure to delete this showcase?",
//             icon: "warning",
//             showCancelButton: false,
//             showDenyButton: true,
//             confirmButtonText: "Confirm",
//             denyButtonText: "Cancel",
//             confirmButtonColor: "#3085d6",
//             denyButtonColor: "#c1c1c1",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 dispatch(deleteShowcase(data[currentShowcase].id)).then(() => {
//                     Swal.fire({
//                         heightAuto: false,
//                         title: 'Success',
//                         text: 'Showcase has been deleted',
//                         icon: 'success'
//                     });

//                     setCurrentShowcase(0)
//                     if (data.length > 0) {
//                         // dispatch(getShowcasePost(data[0].showcase_id, 0, 10))
//                     }
//                 })
//                     .catch((err) => {
//                         tokenAuthorize(err?.response?.status);
//                         Swal.fire({
//                             heightAuto: false,
//                             title: 'Error',
//                             text: 'Cannot delete the showcase',
//                             icon: 'error'
//                         });
//                     })
//             }
//         });
//     }

//     const handleOpenModalAddPost = () => {
//         setSelectedPost(0);
//         setShowAddPost(true)
//         dispatch(getMyPosts())
//     }

//     const handleAddPost = () => {
//         let showcaseId = parseInt(data[currentShowcase].id)
//         let reflectionId = selectedPost

//         const len = showcasePosts?.length === 0 ? 0 : showcasePosts[0].order;
//         if (reflectionId !== 0) {
//             dispatch(addShowcasePost(showcaseId, reflectionId, len)).then(() => {
//                 dispatch(getShowcases())
//                 //dispatch(getShowcasePost(showcaseId, 0, 10))
//             })
//         }
//         else {
//             setShowAddPost(false)
//         }

//     }

//     // const selectedShowcasePosts = data.filter((_, idx) => {
//     //     return idx === currentShowcase
//     // })

//     // const saveList = (list) => {
//     //     localStorage.setItem("theList", JSON.stringify(list));
//     // }

//     const handleDragEnd = (param) => {
//         const srcIdx = param.source.index
//         const desIdx = param.destination?.index
//         if (desIdx) {
//             showcasePosts.splice(desIdx, 0, showcasePosts.splice(srcIdx, 1)[0])
//         }
//     }

//     const editpostorder = () => {
//         seteditPostReorder(!editPostReorder)
//     }

//     const cancelpost = () => {
//         if (postsReorderCancel == true) {
//             Swal.fire({
//                 title: 'Are you sure?',
//                 text: "Changes will not be saved.",
//                 icon: 'warning',
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes',
//                 cancelButtonText: 'No',
//                 reverseButtons: true
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     seteditPostReorder(false)
//                     setpostsReorderCancel(false)
//                     setShowcasePosts((prevState) => {
//                         let updatedTasks = [...showcasePostsCancel];
//                         return updatedTasks;
//                     })
//                 }
//             })
//         } else {
//             seteditPostReorder(false)
//         }
//     }

//     const saveshowcase = () => {
//         seteditPostReorder(false)
//         if (postsReorderCancel == true) {
//             let data = [];
//             let arr = {};
//             showcasePosts.map((t) => (
//                 arr = {
//                     "reflection_id": t.id,
//                     "order": t.order
//                 },
//                 data.push(arr)
//             ))
//             let Id = selectedShowcase?.id
//             axios.put(serverUrl.ShowCaseReorder + "/" + Id, data)
//                 .then((resp) => {
//                     if (resp.status === 200) {
//                         Swal.fire({
//                             title: "Success",
//                             text: "Post has been Updated",
//                             icon: "success",
//                         })
//                         dispatch(getShowcases());
//                         setpostsReorderCancel(false)
//                         // showcasePostsCancel(showcasePosts)
//                         setShowcasePostsCancel((prevState) => {
//                             let updatedTasks = [...showcasePosts];
//                             return updatedTasks;
//                         })
//                     } else {
//                         Swal.fire({
//                             title: "Error",
//                             text: "Post not Updated",
//                             icon: "error",
//                         })
//                     }
//                 })
//                 .catch((error) => {
//                     tokenAuthorize(error?.response?.status);
//                     Swal.fire({
//                         title: "Error",
//                         text: "Post not Updated",
//                         icon: "error",
//                     })
//                 });
//         }
//     }

//     const UpArrow = (itemIndex) => {
//         setpostsReorderCancel(true)
//         setShowcasePosts((prevState) => {
//             let updatedTasks = [...prevState];
//             if (itemIndex == 0) {
//                 var temp = updatedTasks[itemIndex];
//                 updatedTasks[itemIndex] = updatedTasks[updatedTasks?.length - 1];
//                 updatedTasks[showcasePosts?.length - 1] = temp;
//             }
//             if (itemIndex > 0) {
//                 var temp = updatedTasks[itemIndex];
//                 updatedTasks[itemIndex] = updatedTasks[itemIndex - 1];
//                 updatedTasks[itemIndex - 1] = temp;
//             }
//             updatedTasks?.map((i, ind) => (
//                 i.order = showcasePosts.length - ind
//             ))
//             return updatedTasks;
//         });
//     }

//     const DownArrow = (itemIndex) => {
//         setpostsReorderCancel(true);
//         setShowcasePosts((prevState) => {
//             let updatedTasks = [...prevState];
//             if (itemIndex == updatedTasks?.length - 1) {
//                 var temp = updatedTasks[0];
//                 updatedTasks[0] = updatedTasks[updatedTasks?.length - 1];
//                 updatedTasks[updatedTasks?.length - 1] = temp;
//             }
//             if (itemIndex >= 0 && itemIndex != showcasePosts?.length - 1) {
//                 var temp = updatedTasks[itemIndex];
//                 updatedTasks[itemIndex] = updatedTasks[itemIndex + 1];
//                 updatedTasks[itemIndex + 1] = temp;
//             }
//             updatedTasks?.map((i, ind) => (
//                 i.order = showcasePosts.length - ind
//             ))
//             return updatedTasks;
//         });

//     }

//     return (
//         <div>
//             <div className="flex flex-row items-center">
//                 <ShowcaseTab
//                     data={data}
//                     selectedId={currentShowcase}
//                     setPage={showSelectedShowcasePost}
//                 />
//                 <div className="m-3 mb-6 md:right-0">
//                     <ButtonSquare onClick={() => {
//                         setShowcaseNameEmpty(false)
//                         setShowcaseName('')
//                         setShowCreateShowcase(true)
//                     }
//                     } height="10">
//                         <MdAdd className="w-10 h-10" />
//                     </ButtonSquare>
//                 </div>
//                 <ModalCreateShowcase
//                     handleClose={() => setShowCreateShowcase(false)}
//                     show={showCreateShowcase}
//                     onChange={e => setShowcaseName(e.target.value)}
//                     onClick={handleNewShowcase}
//                     showcaseName={showcaseName}
//                     showcaseNameEmpty={showcaseNameEmpty}
//                     showcaseNameExist={showcaseNameExist}
//                     showcaseLoader={newShowcaseStatus.isLoading}

//                 />

//             </div>
//             <hr className="-mt-3" />
//             {/* Showcase Body */}
//             <div className="my-3 mx-3 md:mx-0 mt-7 md:mt-0">
//                 <CardBlue
//                     data={selectedShowcase}
//                     onEdit={() => {
//                         setShowcaseNameEmpty(false)
//                         setShowcaseName('')
//                         setShowEditShowcase(true)
//                     }}
//                     onDelete={handleDeleteShowcase}
//                 />
//                 <ModalEditShowcase
//                     handleClose={() => setShowEditShowcase(false)}
//                     show={showEditShowcase}
//                     onChange={e => setShowcaseName(e.target.value)}
//                     onClick={() => handleEditShowcase(showcaseName)}
//                     selectedShowcase={selectedShowcase.name}
//                     showcaseName={showcaseName}
//                     showcaseNameEmpty={showcaseNameEmpty}
//                     showcaseNameExist={showcaseNameExist}
//                     showcaseLoader={newShowcaseStatus.isLoading}
//                 />
//             </div>
//             {
//                 (!isLoading && showcasePosts) ?
//                     <div>
//                         <div className="flex flex-row relative mx-3 md:mx-0 my-7 md:my-0">
//                             <Button onClick={handleOpenModalAddPost} alt="icon" title="ADD POST" >
//                                 <MdAdd className="w-6 h-6" />
//                             </Button>&nbsp;&nbsp;
//                             {showcasePosts && showcasePosts?.length > 1 ? <>
//                                 {editPostReorder == true ? <Button title="SAVE" onClick={saveshowcase} /> :
//                                     <Button title="REORDER POST" onClick={editpostorder}></Button>}&nbsp;&nbsp;
//                                 {editPostReorder == true && <Button title="CANCEL" onClick={cancelpost}></Button>} </> : <></>}
//                             <ModalAddPost
//                                 show={showAddPost}
//                                 handleClose={() => setShowAddPost(false)}
//                                 onClick={handleAddPost}
//                                 dropdownOption={postOptions}
//                                 value={selectedPost}
//                                 onChange={(e) => setSelectedPost(e.target.value)}
//                                 addPostLoader={newShowcaseStatus.isLoading}
//                                 failed={addPostFailed}
//                                 tabId={data[currentShowcase].id}
//                                 showcasesCount={showcasePosts?.length > 0 ? showcasePosts?.length : 0}
//                             />
//                             <div className="absolute top-2 right-0">
//                                 <TogglePublish
//                                     checked={(selectedShowcase && selectedShowcase.published) ?
//                                         selectedShowcase.published : false
//                                     }
//                                     onChange={handleTogglePublish} />
//                             </div>
//                         </div>
//                         {/* <div className="flex flex-row justify-between mx-3 md:mx-0 my-7 md:my-0">
//                             <div className=""> */}
//                         {
//                             showcasePosts &&
//                             showcasePosts.map((post, index) => (<>
//                                 <div className="flex flex-col">
//                                     {editPostReorder == true &&
//                                         <div className="flex self-end">
//                                             <ButtonCommonTop className="w-6 h-6 cursor-pointer" onClick={() => UpArrow(index)}>
//                                                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16" style={{ paddingLeft: '4px', paddingTop: '3px' }}>
//                                                     <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" />
//                                                 </svg>
//                                             </ButtonCommonTop>
//                                             <ButtonCommonTop className="w-6 h-6 cursor-pointer ml-3" onClick={() => DownArrow(index)}>
//                                                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" style={{ paddingLeft: '4px', paddingTop: '3px' }}>
//                                                     <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
//                                                 </svg>
//                                             </ButtonCommonTop>
//                                         </div>}
//                                     <CardPost
//                                         post={post}
//                                         profile={profile}
//                                         tabId={data[currentShowcase].id}
//                                     />
//                                 </div>
//                                 {/* </div>
//                                         </div> */}
//                                 {/* <div className="flex self-end">
//                                             <div className="w-6 h-6 cursor-pointer" style={{ backgroundColor: 'white' }}>
//                                                 <svg className="w-5 h-5 rotate-top arrow-leftright" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={Up}>
//                                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                                                 </svg>
//                                             </div>
//                                             <div className="w-6 h-6 cursor-pointer ml-3" style={{ backgroundColor: 'white' }}>
//                                                 <svg className="w-5 h-5 rotate-down arrow-leftright" fill="none" stroke="black" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={Down}>
//                                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                                                 </svg>
//                                             </div>
//                                         </div> */}
//                             </>))
//                         }
//                         {/* </div>
//                         </div> */}
//                         {/* <DragDropContext onDragEnd={handleDragEnd}>
//                             <Droppable droppableId="droppable-1">
//                                 {(provided, _) => (
//                                     <div
//                                         ref={provided.innerRef} {...provided.droppableProps}
//                                         className="flex flex-col"
//                                     > */}

//                         {/* {
//                             showcasePosts &&
//                             showcasePosts.map((post, idx) => (
//                                 // <Draggable
//                                 //     key={idx}
//                                 //     draggableId={'draggable-' + post.reflection_id}
//                                 //     index={idx}
//                                 // >
//                                 //     {(provided, snapshot) => (
//                                 //         <div ref={provided.innerRef}
//                                 //             {...provided.draggableProps}
//                                 //             {...provided.dragHandleProps}
//                                 //         >
//                                 <CardPost
//                                     post={post}
//                                     profile={profile}
//                                     tabId={data[currentShowcase].id}
//                                 />
//                                 //         </div>
//                                 //     )}

//                                 // </Draggable>
//                             ))
//                         } */}
//                         {/* {provided.placeholder}
//                                     </div>
//                                 )}

//                             </Droppable>
//                         </DragDropContext> */}
//                     </div>
//                     :
//                     <div className='w-full flex justify-center'>
//                         <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
//                     </div>
//             }
//         </div>
//     )
// }
